var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArticlePattern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 446,
    height: 542,
    viewBox: "0 0 446 542",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2079_36366)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H422C435.255 0 446 10.7452 446 24V542H0V0Z",
    fill: "#1ED760"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M475.959 73.303L435.98 113.147L403.206 80.4855L368.045 115.528",
    stroke: "#E9FBEF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.623 164.848L470.059 234.047",
    stroke: "#E9FBEF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.027 263.573L381.638 227.087",
    stroke: "#E9FBEF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-29 199.759L7.6111 163.273",
    stroke: "#E9FBEF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7832 37.4672L114.259 -15.8269",
    stroke: "#E9FBEF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.226 181.517H264.456V145.756H225.961V106.333",
    stroke: "#E9FBEF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9297 118.674L74.9077 158.518L42.136 191.18L77.2969 226.222",
    stroke: "#E9FBEF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.207 118.258L235.643 49.0598",
    stroke: "#E9FBEF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.572 268.313L250.554 213.331",
    stroke: "#E9FBEF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.539 198.027L161.928 161.538",
    stroke: "#E9FBEF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.462 17.7947L400.623 -15.9309",
    stroke: "#E9FBEF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0915 20.187L-13.75 -13.5386",
    stroke: "#E9FBEF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.334 39.8358L232.242 -35",
    stroke: "#E9FBEF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M9.64059 78.9862C9.92663 71.8954 4.39163 65.9145 -2.72217 65.6275C-9.83597 65.3406 -15.8347 70.8562 -16.1208 77.947C-16.4068 85.0379 -10.8718 91.0188 -3.758 91.3057C3.3558 91.5927 9.35456 86.0771 9.64059 78.9862Z",
    fill: "#E9FBEF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M363.335 31.295C370.454 31.295 376.226 25.5421 376.226 18.4455C376.226 11.3489 370.454 5.59595 363.335 5.59595C356.215 5.59595 350.443 11.3489 350.443 18.4455C350.443 25.5421 356.215 31.295 363.335 31.295Z",
    fill: "#E9FBEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3482 271C19.4678 271 25.2393 265.247 25.2393 258.15C25.2393 251.053 19.4678 245.301 12.3482 245.301C5.22859 245.301 -0.542969 251.053 -0.542969 258.15C-0.542969 265.247 5.22859 271 12.3482 271Z",
    fill: "#E9FBEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.27 253.671C308.39 253.671 314.161 247.919 314.161 240.822C314.161 233.725 308.39 227.972 301.27 227.972C294.15 227.972 288.379 233.725 288.379 240.822C288.379 247.919 294.15 253.671 301.27 253.671Z",
    fill: "#E9FBEF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2079_36366"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H422C435.255 0 446 10.7452 446 24V542H0V0Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArticlePattern);
export default __webpack_public_path__ + "static/media/article-pattern.cf1cf819ab12aa53584e40b211a77c03.svg";
export { ForwardRef as ReactComponent };